import React, { useEffect, useState } from "react";
import CreateLeadPreference from "./CreateLeadPreference";
import ViewPreferenceType from "./ViewPreferenceType";
import { useLocation } from "react-router-dom";

interface LeadDetailsViewProps {
  leadId: number;
}

const LeadPreference: React.FC<LeadDetailsViewProps> = ({ leadId }) => {
  const location = useLocation();
  const [showView, setShowView] = useState<boolean>(true);
  const [refreshTrigger, setRefreshTrigger] = useState<number>(0);

  const toggleView = () => {
    setShowView((prev) => !prev);
  };

  const handlePreferenceSaved = () => {
    console.log("handlePreferenceSaved triggered");
    setRefreshTrigger((prev) => prev + 1);
    setShowView(true);
  };

  return (
    <div className="card">
      <div className="card-header carHeaderWithBtn">
        <h5 className="card-title mb-0">Preference</h5>
        <button
          type="button"
          className="btn btn-sm btn-outline-primary"
          onClick={toggleView}
        >
          {showView ? (
            <>
              <i
                className="bi bi-plus-circle me-1"
                style={{ fontSize: "18px" }}
              ></i>
              Add
            </>
          ) : (
            <>
              <i className="bi bi-eye me-1" style={{ fontSize: "18px" }}></i>
              View
            </>
          )}
        </button>
      </div>
      <div className="card-body">
        <form>
          <div className="row">
            <div className="col-12 col-lg-12 mb-3">
              {showView ? (
                <ViewPreferenceType
                  leadId={location.state?.leadId || leadId}
                  refreshTrigger={refreshTrigger}
                />
              ) : (
                <CreateLeadPreference
                  leadId={location.state?.leadId || leadId}
                  onPreferenceSaved={handlePreferenceSaved}
                />
              )}
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LeadPreference;
